import { combineReducers } from "redux";
import { authReducer } from "./auth/authReducer";
import { boMonReducer } from "./category/boMonReducer";
import { chuyenNganhReducer } from "./category/chuyenNganhReducer";
import { coSoReducer } from "./category/coSoReducer";
import { giaoVienReducer } from "./category/giaoVienReducer";
import { heReducer } from "./category/heReducer";
import { gioiTinhReducer } from "./category/gioiTinhReducer";
import { khoaReducer } from "./category/khoaReducer";
import { lopNamHocReduer } from "./category/lopNamHocReduer";
import { monHocReducer } from "./category/monHocReducer";
import { nganhReducer } from "./category/nganhReducer";
import { nhomLopReducer } from "./category/nhomLopReducer";
import { nhomLopSinhVienReducer } from "./category/nhomLopSinhVienReducer";
import { phongHocReducer } from "./category/phongHocReducer";
import { layoutReducer } from "./common/layoutReducer";
import { chuongTrinhDaoTaoChiTietReducer } from "./ctdt/chuongTrinhDaoTaoChiTietReducer";
import { chuongTrinhDaoTaoKienThucReducer } from "./ctdt/chuongTrinhDaoTaoKienThucReducer";
import { chuongTrinhDaoTaoReducer } from "./ctdt/chuongTrinhDaoTaoReducer";
import { chuongTrinhDaoTaoSoSanhReducer } from "./ctdt/chuongTrinhDaoTaoSoSanhReducer";
import { dangKyHoReducer } from "./dang-ky-ho/dangKyHoReducer";
import { giaiDoanReducer } from "./ke-hoach/giaiDoanReducer";
import { keHoachKyHieuReducer } from "./ke-hoach/keHoachKyHieuReducer";
import { keHoachKyReducer } from "./ke-hoach/keHoachKyReducer";
import { keHoachLopReducer } from "./ke-hoach/keHoachLopReducer";
import { keHoachMonFullPageReducer } from "./ke-hoach/keHoachMonFullPageReducer";
import { xepTkbChuanBiReducer } from "./ke-hoach/xepTkbChuanBiReducer";
import { keHoachMonGhepCapReducer } from "./ke-hoach/keHoachMonGhepCapReducer";
import { keHoachMonHocNamHocHocKyReducer } from "./ke-hoach/keHoachMonHocNamHocHocKyReducer";
import { keHoachMonReducer } from "./ke-hoach/keHoachMonReducer";
import { keHoachNamReducer } from "./ke-hoach/keHoachNamReducer";
import { keHoachTuanReducer } from "./ke-hoach/keHoachTuanReducer";
import { danhSachLopTinChiReducer } from "./lop-tin-chi/danhSachLopTinChiReducer";
import { hocKyDangKyReducer } from "./lop-tin-chi/hocKyDangKyReducer";
import { lopTinChiKetQuaReducer } from "./lop-tin-chi/lopTinChiKetQuaReducer";
import { lopTinChiReducer } from "./lop-tin-chi/lopTinChiReducer";
import { phanGiaoVienReducer } from "./tkb/phanGiaoVienReducer";
import { phanPhongHocReducer } from "./tkb/phanPhongHocReducer";
import { xepTKBReducer } from "./tkb/xepTKBReducer";

import { giangVienReducer } from "./category/giangVienReducer";
import { tangNhaReducer } from "./category/tangNhaReducer";
import { toaNhaReducer } from "./category/toaNhaReducer";
// import { kienThucReducer } from "./category/kienThucReducer";
import { monTuongDuongReducer } from "./category/monTuongDuongReducer";
import { phamViBanReducer } from "./category/phamViBanReducer";
import { rangBuocReducer } from "./category/rangBuocReducer";
import { keHoachMonNVReducer } from "./ke-hoach/keHoachMonNVReducer";
import { caThiReducer } from "./tct/caThiReducer";
import { dotDongTuiReducer } from "./tct/dotDongTuiReducer";
import { dotThiReducer } from "./tct/dotThiReducer";
import { hinhThucThiReducer } from "./tct/hinhThucThiReducer";
import { lichThiSinhVienReducer } from "./tct/lichThiSinhVienReducer";
import { monThiReducer } from "./tct/monThiReducer";
import { phongThiReducer } from "./tct/phongThiReducer";
import { thiSinhReducer } from "./tct/thiSinhReducer";
import { tuiThiReducer } from "./tct/tuiThiReducer";
import { keHoachHocLaiReducer } from "./ke-hoach-hoc-lai/keHoachHocLaiReducer";
import { tietThiReucer } from "./tct/tietThiReucer";
import { thoiKhoaBieuReducer } from "./tkb/thoiKhoaBieuReducer";
import { xepTKBLopTCReducer } from "./tkb/xepTKBLopTCReducer";
import { peReducer } from "./tkb/peReducer";
import { danhSachMoMonReducer } from "./lop-tin-chi/danhSachMoMonReducer";
import { TongHopHocPhiReducer } from "./tong-hop/tongHopHocPhiReducer";
import { phongHocTrongKyReducer } from "./category/phongHocTrongKyReducer";
import { pageSettingReducer } from "./common/pageSettingReducer";
import { chuongTrinhDaoTaoRangBuocReducer } from "./ctdt/chuongTrinhDaoTaoRangBuocReducer";
import { lopReducer } from "./category/lopReducer";
import { hinhThucGiangReducer } from "./category/hinhThucGiangReducer";
import { dmLoaiDangKyHocReducer } from "./category/dmLoaiDangKyHocReducer";
import { dmLoaiLopTinChiReducer } from "./category/dmLoaiLopTinChiReducer";
import { ngayNghiLeReducer } from "./category/ngayNghiLeReducer";
import { quyDinhSoBuoiTrenTuanReducer } from "./category/quyDinhSoBuoiTrenTuanReducer";
import { thoiGianHocLopHCReducer } from "./category/thoiGianHocLopHCReducer";
import { heSoUuTienTKBReducer } from "./category/heSoUuTienTKBReducer";
import { loaiGioHocReducer } from "./category/loaiGioHocReducer";
import { gioHocRangBuocReducer } from "./category/gioHocRangBuocReducer";
import { mlThamSoPhongHocMonHocReducer } from "./category/mlThamSoPhongHocMonHocReducer";
import { phongBanReducer } from "./category/phongBanReducer";
import { phongUuTienBuoiReducer } from "./category/phongUuTienBuoiReducer";
import { phongUuTienNhomReducer } from "./category/phongUuTienNhomReducer";
import { giangVienBanReducer } from "./category/giangVienBanReducer";
import { lopBanReducer } from "./category/lopBanReducer";
import { doiTuongDaoTaoReducer } from "./category/doiTuongDaoTaoReducer";
import { tongHopThongKeReducer } from "./tong-hop-thong-ke/tongHopThongKeReducer";
import { dsDoiTuongDuThiReducer } from "./tct/dsDoiTuongDuThiReducer";
import { keHoachNhomLopReducer } from "./ke-hoach/keHoachNhomLopReducer";
import { quanLyDangKyReducer } from "./quan-ly-dang-ky/quanLyDangKyReducer";
import { quyDinhSoTinChiReducer } from "./quan-ly-dang-ky/quyDinhSoTinChiReducer";
import { lichSuNapDuLieuReducer } from "./quan-ly-dang-ky/lichSuNapDuLieuReducer";
import { keHoachToanKhoaReducer } from "./ke-hoach/keHoachToanKhoaReducer";
import { dangKyChuyenNganhReducer } from "./dang-ky-chuyen-nganh/dangKyChuyenNganhReducer";
import { phanLopChuyenNganhReducer } from "./phan-lop-chuyen-nganh/phanLopChuyenNganhReducer";
const reducers = combineReducers({
  auth: authReducer,
  common: combineReducers({
    layout: layoutReducer,
    pageSetting: pageSettingReducer,
  }),
  category: combineReducers({
    // kienThuc: kienThucReducer,
    nganh: nganhReducer,
    chuyenNganh: chuyenNganhReducer,
    he: heReducer,
    gioiTinh: gioiTinhReducer,
    lopNamHoc: lopNamHocReduer,
    nhomLop: nhomLopReducer,
    nhomLopSinhVien: nhomLopSinhVienReducer,
    monHoc: monHocReducer,
    monTuongDuong: monTuongDuongReducer,
    khoa: khoaReducer,
    boMon: boMonReducer,
    coSo: coSoReducer,
    giaoVien: giaoVienReducer,
    giangVien: giangVienReducer,
    phongHoc: phongHocReducer,
    tangNha: tangNhaReducer,
    toaNha: toaNhaReducer,
    rangBuoc: rangBuocReducer,
    phamViBan: phamViBanReducer,
    phongHocTrongKy: phongHocTrongKyReducer,
    lop: lopReducer,
    hinhThucGiang: hinhThucGiangReducer,
    loaiDangKyHoc: dmLoaiDangKyHocReducer,
    loaiLopTinChi: dmLoaiLopTinChiReducer,
    ngayNghiLe: ngayNghiLeReducer,
    quyDinhSoBuoiTrenTuan: quyDinhSoBuoiTrenTuanReducer,
    thoiGianHocLopHC: thoiGianHocLopHCReducer,
    heSoUuTienTKB: heSoUuTienTKBReducer,
    loaiGioHoc: loaiGioHocReducer,
    gioHocRangBuoc: gioHocRangBuocReducer,
    mlThamSoPhongHocMonHoc: mlThamSoPhongHocMonHocReducer,
    phongBan: phongBanReducer,
    phongUuTienBuoi: phongUuTienBuoiReducer,
    phongUuTienNhom: phongUuTienNhomReducer,
    giangVienBan: giangVienBanReducer,
    lopBan: lopBanReducer,
    doiTuongDaoTao: doiTuongDaoTaoReducer,
  }),
  keHoach: combineReducers({
    keHoachToanKhoa: keHoachToanKhoaReducer,
    keHoachNam: keHoachNamReducer,
    keHoachKy: keHoachKyReducer,
    keHoachTuan: keHoachTuanReducer,
    keHoachLop: keHoachLopReducer,
    keHoachMon: keHoachMonReducer,
    keHoachMonFullPage: keHoachMonFullPageReducer,
    kyHieu: keHoachKyHieuReducer,
    giaiDoan: giaiDoanReducer,
    ghepCap: keHoachMonGhepCapReducer,
    keHoachMonHocNamHocHocKy: keHoachMonHocNamHocHocKyReducer,
    keHoachMonNV: keHoachMonNVReducer,
    keHoachNhomLop: keHoachNhomLopReducer,
    xepTkbChuanBi: xepTkbChuanBiReducer,
  }),
  chuongTrinhDaoTao: combineReducers({
    chuongTrinhDaoTao: chuongTrinhDaoTaoReducer,
    chiTiet: chuongTrinhDaoTaoChiTietReducer,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucReducer,
    chuongTrinhDaoTaoRangBuoc: chuongTrinhDaoTaoRangBuocReducer,
    soSanh: chuongTrinhDaoTaoSoSanhReducer,
  }),
  lopTinChi: combineReducers({
    hocKyDangKy: hocKyDangKyReducer,
    lopTinChi: lopTinChiReducer,
    lopTinChiKetQua: lopTinChiKetQuaReducer,
    danhSachLopTinChi: danhSachLopTinChiReducer,
    danhSachMoMon: danhSachMoMonReducer,
  }),
  tkb: combineReducers({
    thoiKhoaBieu: thoiKhoaBieuReducer,
    xepTKB: xepTKBReducer,
    phanGiaoVien: phanGiaoVienReducer,
    phanPhongHoc: phanPhongHocReducer,
    xepTKBLopTC: xepTKBLopTCReducer,
    pe: peReducer,
  }),
  dangKyHo: dangKyHoReducer,
  toChucThi: combineReducers({
    dotThi: dotThiReducer,
    monThi: monThiReducer,
    phongThi: phongThiReducer,
    thiSinh: thiSinhReducer,
    hinhThucThi: hinhThucThiReducer,
    tuiThi: tuiThiReducer,
    caThi: caThiReducer,
    lichThiSinhVien: lichThiSinhVienReducer,
    dotDongTui: dotDongTuiReducer,
    tietThi: tietThiReucer,
    dsDoiTuongDuThi: dsDoiTuongDuThiReducer,
  }),
  keHoachHocLai: combineReducers({
    keHoach: keHoachHocLaiReducer,
  }),
  tongHop: combineReducers({
    hocPhi: TongHopHocPhiReducer,
    tongHopThongKe: tongHopThongKeReducer,
  }),
  quanLyDangKy: combineReducers({
    quanLyDangKy: quanLyDangKyReducer,
    quyDinhSoTinChi: quyDinhSoTinChiReducer,
    lichSuNapDuLieu: lichSuNapDuLieuReducer,
  }),
  dangKyChuyenNganh: combineReducers({
    dangKyChuyenNganh: dangKyChuyenNganhReducer,
  }),
  phanLopChuyenNganh: combineReducers({
    phanLopChuyenNganh: phanLopChuyenNganhReducer,
  }),
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
